import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";
import { IAddOfferingForGroup, IOfferGroupFetchParams } from "../../types/IOfferingGroup";
import { IOfferingGroupUpdate } from "../../types/IOfferingGroupCreate";
import { IOfferingGroupsAddOfferSearch } from "../../types/IOfferingGroupsSearch";

export const offeringGroupsSearchRoute = (
  searchParams: Partial<
    | IOfferingGroupsAddOfferSearch<string>["searchAllGroups"]
    | IOfferingGroupsAddOfferSearch<string>["searchInqludesGroups"]
  >
) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups", "search"].join("/"),
    searchParams: { ...searchParams },
  });
};

export const offeringGroupIdSearchRoute = (offeringGroupid: number) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups", offeringGroupid].join("/"),
  });
};

export const getOfferingGroupsDicRoute = (dictType: string) =>
  buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${dictType}` });

export const fetchOfferingGroupsVersionsRoute = (offeringGroupId: number) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups", offeringGroupId, "versions"].join("/"),
  });
};

export const fetchOfferingGroupIdRoute = (params: {
  offeringGroupId: number;
  searchParams?: IOfferGroupFetchParams;
}) => {
  const {
    offeringGroupId,
    searchParams = {
      includeFutureDatesMembers: true,
    },
  } = params;
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups", offeringGroupId].join("/"),
    searchParams: { ...searchParams },
  });
};

export const createOfferingGroupRoute = () => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups"].join("/"),
  });
};

export const updateOfferingGroupRoute = ({
  offeringGroupId,
  params,
}: IOfferingGroupUpdate["params"]) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups", offeringGroupId].join("/"),
    searchParams: {
      ...params,
    },
  });
};

export const updateOfferingGroupCloseDateRoute = (params: {
  offeringGroupId: number;
  onDate?: string;
}) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-groups", params.offeringGroupId].join("/"),
    searchParams: {
      onDate: params?.onDate,
    },
  });
};

export const updateOfferingGroupMemberCloseDateRoute = (params: {
  offeringGroupId: number;
  memberId: number;
  onDate?: string;
}) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-group-members", params.memberId, "close"].join("/"),
    searchParams: {
      onDate: params?.onDate,
    },
  });
};

export const deleteOfferingGroupMemberRoute = (params: {
  offeringGroupId: number;
  memberId: number;
  onDate?: string;
}) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-group-members", params.memberId, "delete"].join("/"),
  });
};

export const addedOfferingGroupMemberRoute = () => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-group-members"].join("/"),
  });
};

export const fetchOfferingGroupsPolicyRoute = (params) => {
  return buildUrl({
    url: [baseUrl, "offerings-api", "offering-policies", "search"].join("/"),
    searchParams: {
      ...params,
    },
  });
};

export const addOfferingForGroupRoute = (params: IAddOfferingForGroup) => {
  return buildUrl({
    url: [
      baseUrl,
      "offerings-api",
      "offering-group-members",
      params.offeringGroupMember.minCardinality ? "copy" : "add-as-template",
    ].join("/"),
  });
};
